import React from 'react';

import type { ViewMoreModalParamsContextValue } from './ViewMoreModalParamsContextValue';

export const ViewMoreModalParamsContext: React.Context<ViewMoreModalParamsContextValue | null> =
	React.createContext<ViewMoreModalParamsContextValue | null>(null);
